import { axios } from "../../helpers/axios";
import { EMAIL_NOTIFICATION_URL } from "./emailNotificationConstants";

export const api_get_email_notification_list_url = async (page, limit, qn, qs) => {
    return axios.get(EMAIL_NOTIFICATION_URL, { params: { page, limit, qn, qs } });
};

export const api_create_email_notification_url = async (data) => {
    return axios.post(EMAIL_NOTIFICATION_URL, data);
};

export const api_update_email_notification_url = async (email_notification_id, updated_data) => {
    return axios.put(EMAIL_NOTIFICATION_URL + "/" + email_notification_id, updated_data);
};

export const api_activate_deactivate_email_notification_url = async (email_notification_id, updated_data) => {
    return axios.patch(EMAIL_NOTIFICATION_URL + "/" + email_notification_id + "/" + updated_data);
};

export const api_get_email_notification_details_url = async (email_notification_id) => {
    return axios.get(EMAIL_NOTIFICATION_URL + "/" + email_notification_id);
};
